import axios from 'axios';
import { GET_DIVISIONS, GET_SPECIFIC_DIVISION, ADD_DIVISIONS, EDIT_DIVISION, ANSWER_DIVISION, DELETE_DIVISION, CLEAR_DIVISIONS, DIVISIONS_LOADING, UPDATE_BIEN_DIVISION, UPDATE_BIEN_DOA } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { IDivision } from '../../types/interfaces';
import store from '../store';

export const getDivisions = () => (dispatch: Function, getState: Function) => {
  dispatch({
    type: DIVISIONS_LOADING
  });
  axios
    .get('/api/divisions', {...tokenConfig(getState), params: {}})
    .then(res =>
      dispatch({
        type: GET_DIVISIONS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getDivisionByBienId = async (bienId: number) : Promise<any> => {
  return new Promise((resolve) => {
  axios
    .get('/api/divisions/byBienId', {...tokenConfig(store.getState), params: {bienId}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
      console.log("err", err)
    });
  });
};

export const addDivision = (bienIds: number[], floors: any[], assVenteIdImage: number | undefined, association: any, divisionSampleId: number | undefined, saveSample: number, sampleName: string, withDoa: number, userId: number | undefined, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/divisions', {bienIds, floors, assVenteIdImage, association, divisionSampleId, saveSample, sampleName, withDoa, userId}, tokenConfig(getState))
    .then(res =>{
      dispatch({
        type: ADD_DIVISIONS,
        payload: res.data.divisions
      });
      dispatch({
        type: UPDATE_BIEN_DIVISION,
        payload: res.data.divisions
      });
      if(res.data.doa)
        dispatch({
          type: UPDATE_BIEN_DOA,
          payload: res.data.doas
        });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const answerDivision = (id: number, bien_id: number, approved: number, saveSample: number, sampleName: string, by_user_id: number | undefined, by_username: string | undefined, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/divisions/answer', {id, bien_id, approved, saveSample, sampleName, by_user_id, by_username}, tokenConfig(getState))
    .then(res => {
      if(approved === 1)
        dispatch({
          type: ANSWER_DIVISION,
          payload: res.data
        });
      else
        dispatch({
          type: DELETE_DIVISION,
          payload: id
        });
      // dispatch({
      //   type: UPDATE_BIEN_DOA,
      //   payload: res.data
      // });
      callback(res.data, approved)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const deleteDivision = (id: number, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .delete(`/api/divisions/${id}`, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: DELETE_DIVISION,
        payload: id
      })
      callback(true)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const clearDivisions = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_DIVISIONS
  })
};